// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 260px;
  background: none #fdfdfd;
  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);
  border: 1px solid #999;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 4px;
}

.root:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  top: -10px;
  left: 10px;
  border: 5px solid transparent;
  border-bottom-color: #999;
}

.root:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  top: -9px;
  left: 10px;
  border: 5px solid transparent;
  border-bottom-color: #fdfdfd;
}

.inner {
  display: flex;
}

.input {
  display: block;
  flex: 1 0 auto;
  height: 30px;
  background: none white;
  border: 1px solid #999;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 2px 6px;
  font-family: inherit;
  font-size: inherit;
  line-height: 24px;
}

.inner .buttonGroup {
  flex: 0 1 auto;
  margin-left: 4px;
  margin-bottom: 0;
}

.checkOption {
  margin: 8px 2px;
}

.checkOption input {
  margin-right: 8px;
}

.checkOption input {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/ui/InputPopover.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,wBAAwB;EACxB,+DAA+D;EAC/D,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".root {\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  width: 260px;\n  background: none #fdfdfd;\n  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);\n  border: 1px solid #999;\n  border-radius: 2px;\n  box-sizing: border-box;\n  padding: 4px;\n}\n\n.root:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: -10px;\n  left: 10px;\n  border: 5px solid transparent;\n  border-bottom-color: #999;\n}\n\n.root:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: -9px;\n  left: 10px;\n  border: 5px solid transparent;\n  border-bottom-color: #fdfdfd;\n}\n\n.inner {\n  display: flex;\n}\n\n.input {\n  display: block;\n  flex: 1 0 auto;\n  height: 30px;\n  background: none white;\n  border: 1px solid #999;\n  border-radius: 2px;\n  box-sizing: border-box;\n  padding: 2px 6px;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 24px;\n}\n\n.inner .buttonGroup {\n  flex: 0 1 auto;\n  margin-left: 4px;\n  margin-bottom: 0;\n}\n\n.checkOption {\n  margin: 8px 2px;\n}\n\n.checkOption input {\n  margin-right: 8px;\n}\n\n.checkOption input {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
